export const BOARD_SETTINGS_GET_ALL_DATA = 'BOARD_SETTINGS_GET_ALL_DATA';
export const SWAP_STAGE_ORDER = 'SWAP_STAGE_ORDER';


export function boardSettingsGetAllData(data) {
  return {
    type: BOARD_SETTINGS_GET_ALL_DATA,
    payload: data,
  }
}

export function swapStageOrder(data) {
  return {
    type: SWAP_STAGE_ORDER,
    payload: data,
  }
}


// WEBPACK FOOTER //
// ./src/actions/boardSettings/index.js